import React, { FC, useState, useEffect, useRef } from 'react'
import {
  Container,
  StyledIconColored,
  Title,
  StyledChevron,
  DropOptions,
  DropOptionsTitle,
  DropItemWrapper,
  DropOptionItem,
  Divider,
  SoonText,
  BetaText
} from './styles'
import Chevron from './chevron.svg'
import { useUi } from '../../context/ui.context'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../context/user.context'
type TabProps = {
  defaultIcon: any,
  hoverIcon: any,
  icon?: any,
  title:string,
  dropOptions?:boolean,
  active:boolean,
  dropOptionsArr?:any[],
  isSmall:boolean,
  activeText:boolean,
  isDown?:boolean,
  onClick?:any,
  isFirst?:boolean,
  isSoon?:boolean,
  href:string,
  viewIfNoClient?:boolean,
  isBeta?:boolean,
  ref?:any,
}

const SideBarTab:FC<TabProps> = (props) => {
  const {
    defaultIcon,
    hoverIcon,
    title,
    dropOptions,
    dropOptionsArr,
    active,
    isSmall,
    activeText,
    isDown,
    onClick,
    isFirst,
    isSoon,
    href,
    viewIfNoClient,
    isBeta,
    icon,
    ref,
  } = props
  const [hover, setHover] = useState<boolean>(false)
  const [activeDrop, setActiveDrop] = useState<boolean>(false)
  const dropOptionsRef:any = useRef(null)
  const dropOptionsParrentRef:any = useRef(null)
  const {user} = useAuth()
  const {themeDark} = useUi()
  const [t] = useTranslation()
  // useEffect(() => {
  //   document.addEventListener('click', handleClickOutside, true);
  //   return () => {
  //     document.removeEventListener('click', handleClickOutside, true);
  //   };
  // },[]);

  //   const handleClickOutside:any = (event:any) => {
  //     if (dropOptionsRef  && !dropOptionsRef.current.contains(event.target) && !dropOptionsParrentRef.current.contains(event.target)){
  //       setActiveDrop(false)
  //     }
  //   }


  return(
    <Container

      style={isFirst ? {marginTop:'76px'} : {}}
      isSmall={isSmall}
      to={href}
      // disabled={(!user?.user?.active_client && !viewIfNoClient) || isSoon}
      // onClick={dropOptions ? () => {
      //   setActiveDrop(!activeDrop)
      //   if(onClick && (viewIfNoClient && user.user.active_client)){
      //     onClick()
      //   } 
      // } : onClick}
      active={!isSoon && active}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      // ref={ref}
      // isSoon={isSoon || (!viewIfNoClient && !user.user.active_client)}
    >
      <div style={{display:'flex'}}>
        {defaultIcon ?
        <StyledIconColored src={(hover && !isSoon) && (viewIfNoClient && user?.user?.active_client) || (active && !isSoon)  ? themeDark ? defaultIcon : hoverIcon : defaultIcon}/>
        :
          // <span className="material-icons">{icon}</span>
          null
        }
        <Title isSmall={isSmall}>
          {!activeText ? '' : title?.replaceAll('_', ' ')}
          {isSoon && activeText ? <SoonText>{isBeta ? "BETA" : t("SOON")}</SoonText> : ''}
          {isBeta && !isSoon && activeText && <BetaText>BETA</BetaText>}
        </Title>
      </div>
    </Container>
  )
}

export default SideBarTab
